import { render, staticRenderFns } from "./InvoiceBrowser.yaml?vue&type=template&id=46749b3e&component"
import script from "./InvoiceBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports